import type { FavoritesRequestData } from './types';

import { URL } from '../../constants';
import { ServiceConfig } from '../../utils/create-http-api-service';
import { defaultRequestService } from '../../utils/default-request-service';

export const addToFavorites = (
  config: ServiceConfig,
  requestData: FavoritesRequestData,
) => {
  type AdapterProps = { request: typeof requestData };

  return defaultRequestService<AdapterProps>(URL.FAVORITES_CATEGORIES, config.instance.put, {
    requestData,
  });
};

export const removeFromFavorites = (
  config: ServiceConfig,
  requestData: FavoritesRequestData,
) => {
  type AdapterProps = { request: typeof requestData };

  return defaultRequestService<AdapterProps>(URL.FAVORITES_CATEGORIES, config.instance.delete, {
    requestData,
    requestConfig: {
      method: 'delete',
    },
  });
};
